{
	"invalidListItem": "El valor ingresado no está en la lista de opciones válidas.",
	"invalidListTitle": "Valor inválido",
	"selectAValidOption": "Por favor, seleccione una opción válida.",
	"selectAValue": "Seleccione un valor",
	"invalidValue": "El valor ingresado no es válido.",
	"values": {
		"boolean": {
			"true": "Sí",
			"false": "No"
		}
	}
}
